<div *ngIf="data">
    <div>{{data.equal}}</div>
    <div>{{data.number}}</div>
</div>